const en_master_attribute = {
    "": "attribute",
    name: "attribute name",
    add: "add attribute",
    edit: "edit attribute",

    error: {
        name: "Attribute name cannot be empty.",
        create: "Failed to create attribute.",
        delete: "Failed to delete attribute.",
        edit: "Failed to update attribute.",
    },

    success: {
        create: "Attribute created successfully.",
        delete: "Attribute deleted successfully.",
        edit: "Attribute updated successfully.",
    }
}

export default en_master_attribute;